import {
   APP_BASE_URL,
   DEV_SERVER_HOST_NAME,
   HOME_SITE_URL
} from '@flowwai-frontend/shared/constants'
import { getAppHostNameFromURL } from '../MiscellaneousUtils/MiscellaneousUtils'

export const redirectToHomeSite = (): void => {
   window.location.href = HOME_SITE_URL
}

export const guardEmbedding = (): void => {
   const windowLocation = window.top?.location

   try {
      const hostName = windowLocation?.hostname
   } catch (e) {
      console.error('Accessing the app from unknown host is prohibited')

      redirectToHomeSite()

      return
   }

   const appHostName = getAppHostNameFromURL(APP_BASE_URL)

   const isUnknownHost =
      windowLocation?.hostname !== DEV_SERVER_HOST_NAME &&
      windowLocation?.hostname !== appHostName

   if (isUnknownHost) {
      console.error(
         `Accessing the app from unknown host, host => ${appHostName}, windowHost => ${windowLocation?.hostname}`
      )

      redirectToHomeSite()

      return
   }
}
